module.exports = __WEBPACK_EXTERNAL_MODULE_https_cdn_web_vanguard_com_c11n_web_b6_select_js_970b860a__;